import {videojs} from './PlayerComponentWrapper';

// Transform object to class - FIRST PART
interface IMenuButtonComponentWrapper extends VideoJSButtonComponent{}
let IMenuButtonComponentWrapper = <VideoJSMenuButtonComponent><any>(videojs.getComponent('MenuButton'));


// Transform object to class - SECOND PART (extends wrapper class with object information's (interface))
export default class MenuButtonComponentWrapper extends IMenuButtonComponentWrapper<VideoJSMenuButtonComponent>{ // define type for generic constructor return type: IComponentWrapper

}



// WEBPACK FOOTER //
// ./src/app/components/wrappers/MenuButtonComponentWrapper.ts